var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowUpLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M63.91 40.024c-13.188.004-23.883 10.698-23.886 23.886L40 175.84c0 6.594 5.343 11.938 11.937 11.937l18.334-.004c6.595-.001 11.942-5.348 11.943-11.943l.014-65.444 126.699 126.698c3.888 3.888 10.19 3.888 14.079 0l14.078-14.078c3.888-3.888 3.888-10.191 0-14.079L110.386 82.228l65.444-.014c6.595-.001 11.941-5.348 11.943-11.942l.004-18.335C187.778 45.343 182.434 40 175.839 40z"
})));
export default SvgArrowUpLeft;